var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { Component } from "react";
import { orderBy } from "lodash";
import id from "@irati/utils/id";
import { injectIntl } from "@irati/utils/lang";
import OccasionsService from "@irati/recognition/services/Occasions";
import FullModal from "@irati/ui/src/FullModal";
import OccasionsTab from "./OccasionsTab";
import EditForm from "./EditForm";
import TitleAndCreate from "./TitleAndCreate";
import { Tabs } from "./styled";
var CompanyValuesList = /** @class */ (function (_super) {
    __extends(CompanyValuesList, _super);
    function CompanyValuesList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            activeOccasions: [],
            hiddenOccasions: [],
            selectedOccasion: null,
            showCreateModal: false
        };
        _this.getOccasions = function () {
            OccasionsService.getAll().then(function (occasions) {
                var sortedOccasions = orderBy(occasions, "createdAt", "desc");
                var activeOccasions = sortedOccasions.filter(function (occasion) { return !occasion.archived; });
                var hiddenOccasions = sortedOccasions.filter(function (occasion) { return occasion.archived; });
                _this.setState({ activeOccasions: activeOccasions, hiddenOccasions: hiddenOccasions });
            });
        };
        _this.editOccasion = function (selectedOccasion) {
            _this.setState({ selectedOccasion: selectedOccasion }, _this.showModal);
        };
        _this.showModal = function () {
            _this.setState({ showCreateModal: true });
        };
        _this.closeModal = function () {
            _this.setState({
                showCreateModal: false,
                selectedOccasion: null
            });
        };
        _this.upsertOccasion = function (name, tag, iconHref, occasionId) {
            var occasion = {
                name: name,
                desc: name,
                tag: tag,
                icon: {
                    href: iconHref,
                    alt: name
                }
            };
            if (occasionId) {
                return OccasionsService.update(occasion, occasionId).then(function () {
                    _this.closeModal();
                    _this.getOccasions();
                });
            }
            else {
                return OccasionsService.create(occasion).then(function () {
                    _this.closeModal();
                    _this.getOccasions();
                });
            }
        };
        _this.hideOccasion = function (occasion) {
            OccasionsService.hide(occasion).then(_this.getOccasions);
        };
        _this.showOccasion = function (occasion) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                OccasionsService.show(occasion).then(this.getOccasions);
                return [2 /*return*/];
            });
        }); };
        return _this;
    }
    CompanyValuesList.prototype.componentDidMount = function () {
        this.getOccasions();
    };
    CompanyValuesList.prototype.render = function () {
        var formatMessage = this.props.formatMessage;
        var _a = this.state, activeOccasions = _a.activeOccasions, hiddenOccasions = _a.hiddenOccasions, showCreateModal = _a.showCreateModal, selectedOccasion = _a.selectedOccasion;
        var idNamespace = id("occasion-tabs", this.props);
        return (React.createElement(React.Fragment, null,
            React.createElement(TitleAndCreate, { title: "admin.occasions.list.header", buttonLabel: "admin.occasions.button.create", showForm: this.showModal }),
            React.createElement(Tabs, { id: idNamespace, mountOnEnter: true, unmountOnExit: true, tabs: [
                    {
                        title: formatMessage({ id: "admin.occasions.tabs.active" }, { count: activeOccasions.length }),
                        key: "active",
                        component: (React.createElement(OccasionsTab, { items: activeOccasions, description: "admin.occasions.active.description", hide: this.hideOccasion, show: this.showOccasion, edit: this.editOccasion }))
                    },
                    {
                        title: formatMessage({ id: "admin.occasions.tabs.hidden" }, { count: hiddenOccasions.length }),
                        key: "hidden",
                        component: (React.createElement(OccasionsTab, { items: hiddenOccasions, description: "admin.occasions.hidden.description", hide: this.hideOccasion, show: this.showOccasion }))
                    }
                ] }),
            React.createElement(FullModal, { id: idNamespace, onHide: this.closeModal, show: showCreateModal },
                React.createElement(EditForm, { occasion: selectedOccasion, upsertOccasion: this.upsertOccasion, closeModal: this.closeModal }))));
    };
    return CompanyValuesList;
}(Component));
export default injectIntl(CompanyValuesList);
